import React from "react";
import {Icon, Text, Flex} from "@chakra-ui/react";
import {MdCancel, MdCheckCircle, MdOutlineError} from "react-icons/md";
import {RENTAL_STATUS} from "../../variables/rentalStatus";

export default function RentalStatus(props) {

    const status = props.status;

    return (
        <Flex alignItems={"center"}>
            <Icon
                w='24px'
                h='24px'
                me='5px'
                color={
                    status === RENTAL_STATUS.ONLINE
                        ? "green.500"
                        : status === RENTAL_STATUS.OFFLINE
                            ? "red.500"
                            : status === RENTAL_STATUS.UNFINISHED
                                ? "orange.500"
                                : null
                }
                as={
                    status === RENTAL_STATUS.ONLINE
                        ? MdCheckCircle
                        : status === RENTAL_STATUS.OFFLINE
                            ? MdCancel
                            : status === RENTAL_STATUS.UNFINISHED
                                ? MdOutlineError
                                : null
                }
            />
            <Text>
                {status === RENTAL_STATUS.ONLINE
                    ? "inseriert"
                    : status === RENTAL_STATUS.OFFLINE
                        ? "nicht inseriert"
                        : status === RENTAL_STATUS.UNFINISHED
                            ? "in Bearbeitung"
                            : null}
            </Text>
        </Flex>
    );
}
